export default __webpack_public_path__ + "static/media/WalkwayTurn.256.ba56ff23.png";